import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import PeopleIcon from "@mui/icons-material/People";
import DevicesIcon from "@mui/icons-material/Devices";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ReportIcon from "@mui/icons-material/Report";
import { logoStyle2, Root, drawer } from "../style/style";
import HubIcon from "@mui/icons-material/Hub";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import EngineeringIcon from "@mui/icons-material/Engineering";
import DescriptionIcon from "@mui/icons-material/Description";
import { loginContext, adminDrawerContext } from "../context/contexts";
import { getKeyByValue } from "../context/contextmanager";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";

export default function AdminDrawer() {
  const [active, setactive] = useState(false);
  const textContext = useContext(adminDrawerContext);

  //const [buttonText, setbuttonText] = useState(text.buttonText);

  const context = useContext(loginContext);

  const history = useNavigate();

  const handleClick = (text) => {
    textContext.setbuttonText(text);
    // setbuttonText(text)
    if (text === "Logout") {
      handleLogout();
    } else {
      setactive(!active);
      sessionStorage.setItem("page_number", 1);
      sessionStorage.setItem("hub_page", 1);
      sessionStorage.removeItem("page_org");
      sessionStorage.removeItem("search");

      // Clear billing details if navigating away from Customer Billing
      if (sessionStorage.getItem("billingCustomerId")) {
        sessionStorage.removeItem("billingCustomerId");
        sessionStorage.removeItem("billingCustomerName");
        sessionStorage.removeItem("billingMonth");
        sessionStorage.removeItem("billingYear");
        sessionStorage.removeItem("billingFromUtc");
        sessionStorage.removeItem("billingToUtc");
      }

      if (text === "Replace Device") {
        text = "replaceDevice";
      }
      if (text === "Change Billing Type") {
        text = "ChangeBillingType";
      }
      if (text === "Customer Billing") {
        text = "CustomerBilling";
      }

      const nm = getKeyByValue(context.page, true);
      context.setpage({
        ...context.page,
        [nm]: false,
        [text]: true,
      });
    }
  };
  const handleLogout = () => {
    sessionStorage.setItem("token", "");
    history({ pathname: "/" });
    window.location.reload(true);
    localStorage.setItem("role", "");
  };

  return (
    <Root>
      <div className="drawer-admin">
        <Drawer sx={drawer} variant="permanent" anchor="left">
          <div>
            <img
              style={logoStyle2}
              // src="https://zewa-logo-bucket.s3.us-west-2.amazonaws.com/rpm-logo2.png"
              src="https://zewa-logo-bucket.s3.amazonaws.com/rpm-logo.png"
              // src="https://zewa-logo-bucket-prod.s3.amazonaws.com/logo/Zewa+Connect+White.png"
              alt="logo"
            />
            <List>
              {[
                "Distributors",
                "Organizations",
                "Devices",
                "Hubs",
                "Settings",
                "ManufacturedDevices",
                "Replace Device",
                "Change Billing Type",
                "Customer Billing",
                "Admins",
                "Logout",
              ].map((text, index) => (
                <ListItem
                  key={text}
                  disablePadding
                  className={
                    text === textContext.buttonText
                      ? "active drawer-item"
                      : "drawer-item"
                  }
                >
                  <ListItemButton
                    onClick={() => {
                      handleClick(text);
                    }}
                  >
                    <ListItemIcon>
                      {index === 0 && (
                        <EngineeringIcon style={{ color: "white" }} />
                      )}
                      {index === 1 && <PeopleIcon style={{ color: "white" }} />}
                      {index === 2 && (
                        <DevicesIcon style={{ color: "white" }} />
                      )}
                      {index === 3 && <HubIcon style={{ color: "white" }} />}
                      {index === 4 && (
                        <SettingsIcon style={{ color: "white" }} />
                      )}
                      {index === 5 && (
                        <UploadFileIcon style={{ color: "white" }} />
                      )}
                      {index === 6 && <ReportIcon style={{ color: "white" }} />}
                      {index === 7 && (
                        <ChangeCircleIcon style={{ color: "white" }} />
                      )}
                      {index === 8 && (
                        <DescriptionIcon style={{ color: "white" }} />
                      )}
                      {index === 9 && (
                        <AdminPanelSettingsIcon style={{ color: "white" }} />
                      )}
                      {index === 10 && (
                        <LogoutIcon style={{ color: "white" }} />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        text !== "ManufacturedDevice" ? text : "Device file"
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </div>
        </Drawer>
      </div>
    </Root>
  );
}
